(function () {
  // Shopify page handle stays new-account-register; code uses "profile completion" naming.
  var DEFAULT_PROFILE_COMPLETION_PAGE_PATH = '/pages/new-account-register';

  function normalizeReturnTo(value) {
    var normalized = (value || '').trim();

    if (!normalized || normalized.charAt(0) !== '/' || normalized.indexOf('//') === 0) {
      return '';
    }

    return normalized;
  }

  function buildPostOtpCompletionReturnTo(profileCompletionPath, originalReturnTo) {
    var url = new URL(profileCompletionPath || DEFAULT_PROFILE_COMPLETION_PAGE_PATH, window.location.origin);
    url.searchParams.set('post_otp', '1');

    var normalized = normalizeReturnTo(originalReturnTo);
    if (normalized && normalized.indexOf('new-account-register') === -1) {
      url.searchParams.set('return_to', normalized);
    }

    return url.pathname + url.search;
  }

  function resolveOtpLoginReturnTo(profileCompletionPath, originalReturnTo, profileCompleted) {
    if (profileCompleted) {
      return normalizeReturnTo(originalReturnTo) || '/account';
    }

    return buildPostOtpCompletionReturnTo(profileCompletionPath, originalReturnTo);
  }

  function currentReturnToFromLocation() {
    var params = new URLSearchParams(window.location.search);
    params.delete('post_otp');
    params.delete('gate');
    var qs = params.toString();

    return normalizeReturnTo(window.location.pathname + (qs ? '?' + qs : ''));
  }

  window.HmAccountReturnTo = {
    normalizeReturnTo: normalizeReturnTo,
    buildPostOtpCompletionReturnTo: buildPostOtpCompletionReturnTo,
    resolveOtpLoginReturnTo: resolveOtpLoginReturnTo,
    currentReturnToFromLocation: currentReturnToFromLocation
  };
})();
